import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { CONTENT } from "@/content";
import { errorText, useApi } from "@/lib/api";

const A = CONTENT.admin;

export const UsersPanel = () => {
  const api = useApi();
  const [data, setData] = useState(null);
  const load = useCallback(() => api("get", "/users").then(setData).catch((e) => toast.error(errorText(e))), [api]);
  useEffect(() => { load(); }, [load]);

  const change = async (userId, role) => {
    try { await api("patch", `/users/${userId}/role`, { role }); toast.success(A.roleSaved); }
    catch (e) { toast.error(errorText(e)); }
    load();
  };

  if (!data) return <p className="muted">{A.loading}</p>;
  return (
    <>
      <h2 className="admin-h2">{A.usersTitle}</h2>
      <ul className="content-list" data-testid="users-list">
        {data.users.map((u) => (
          <li key={u.user_id} className="nb-card content-row" data-testid={`user-row-${u.user_id}`}>
            <p className="row-title">{u.email || u.user_id}</p>
            <select className="nb-input role-select" value={u.role} onChange={(e) => change(u.user_id, e.target.value)} data-testid={`user-role-select-${u.user_id}`}>
              {data.roles.map((r) => <option key={r} value={r}>{A.roleNames[r] || r}</option>)}
            </select>
          </li>
        ))}
      </ul>
    </>
  );
};
